import { gql } from "@apollo/client"
import { RemoteWorkCostsTemplateFragment } from "./RemoteWorkCostsFragment"
import { VariableCompensationTemplateFragment } from "./VariableCompensationFragment"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "./PlanContributionSettingFragment"
import { EmploymentTemplate } from "@oysterhr/schema"

export const BENEFITS_ENROLLMENT_TEMPLATE_FRAGMENT = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  fragment BenefitsEnrollmentTemplateFragment on BenefitsEnrollmentTemplateType {
    id
    tier {
      id
      name
      includedPlans {
        id
        name
        provider {
          id
          name
        }
      }
    }
    pensions {
      plan {
        id
        name
        provider {
          id
          name
        }
        ...PlanContributionSettingFragment
      }
      costContribution {
        contributor
        amountAsPercentage
      }
    }
    supplementaryBenefits {
      id
      name
      category
      provider {
        id
        name
      }
    }
    preferredCostSplit {
      planId
      plan {
        id
        provider {
          name
        }
        name
        costSplitAllowed
      }
      employerContribution
      dependentsEmployerContribution
      dependentsEmployerContributionMaxCount
    }
  }
`

export const EmploymentTemplateFragment = gql`
  ${BENEFITS_ENROLLMENT_TEMPLATE_FRAGMENT}
  fragment EmploymentTemplateFragment on EmploymentTemplate {
    commissionPlan {
      id
      title
      description
      filename
    }
    commissionPlanOffered
    company {
      id
      paymentCurrencyCode
    }
    countryCode
    description
    equityOffered
    id
    name
    oysterScore
    paidHolidayDays
    probationPeriod
    status

    variableCompensationTemplates {
      ...VariableCompensationTemplateFragment
    }
    remoteWorkCosts {
      ...RemoteWorkCostsTemplateFragment
    }
    benefitsEnrollmentTemplate {
      ...BenefitsEnrollmentTemplateFragment
    }
  }

  ${VariableCompensationTemplateFragment}
  ${RemoteWorkCostsTemplateFragment}
`

export type EmploymentTemplateFragment = Pick<
  EmploymentTemplate,
  | "id"
  | "name"
  | "oysterScore"
  | "description"
  | "countryCode"
  | "status"
  | "commissionPlanOffered"
  | "equityOffered"
  | "paidHolidayDays"
  | "probationPeriod"
  | "variableCompensationTemplates"
  | "remoteWorkCosts"
  | "benefitsEnrollmentTemplate"
>
